import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { OperatorThemeService } from '../theme/operator-theme.service';
import { TenantService } from '../tenant/tenant.service';
import { AppIconComponent } from '../../shared/components/app-icon/app-icon.component';
import { AuthStateService } from '../../features/auth/data/auth-state.service';
import { FOOTER_QUICK_LINKS, NAV_ITEMS } from '../../features/home/data/home.mock';

@Component({
  selector: 'app-consumer-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, AppIconComponent],
  templateUrl: './consumer-layout.component.html',
  styleUrl: './consumer-layout.component.scss',
})
export class ConsumerLayoutComponent {
  private readonly tenantService = inject(TenantService);
  private readonly themeService = inject(OperatorThemeService);
  private readonly authState = inject(AuthStateService);

  readonly navItems = NAV_ITEMS;
  readonly footerLinks = FOOTER_QUICK_LINKS;

  readonly isAuthenticated = this.authState.isAuthenticated;
  readonly userEmail = computed(() => this.authState.session()?.email ?? '');

  readonly menuOpen = signal(false);

  toggleMenu(): void {
    this.menuOpen.update((open) => !open);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  logout(): void {
    this.authState.logout();
    this.closeMenu();
  }

  readonly operatorName = computed(() => this.tenantService.operator()?.name ?? 'DURADRIVE');

  readonly contactPhone = computed(
    () => this.tenantService.operator()?.contactPhone?.trim() || '+63 917 000 0000',
  );

  readonly contactEmail = computed(
    () => this.tenantService.operator()?.contactEmail?.trim() || 'admin@example.com',
  );

  readonly terminalLabel = computed(
    () => this.tenantService.operator()?.address?.trim() || 'Manila Cubao',
  );

  readonly logoUrl = computed(() => {
    const theme = this.themeService.theme();
    const operator = this.tenantService.operator();

    return theme?.primaryLogoUrl ?? theme?.logoDarkBgUrl ?? operator?.logoUrl ?? null;
  });

  readonly operatorInitials = computed(() => {
    const name = this.operatorName();
    const parts = name.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) {
      return 'DD';
    }

    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  });
}
